"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyUnhandledExceptionHandler = exports.fireAndForget = void 0;
var slackNotify_1 = require("./slackNotify");
var fireAndForget = function (promise) {
    promise.catch(function (err) { });
};
exports.fireAndForget = fireAndForget;
var applyUnhandledExceptionHandler = function (workerName) {
    process.on('unhandledRejection', function (reason, promise) {
        (0, exports.fireAndForget)((0, slackNotify_1.slackNotify)("[".concat(workerName, "] Unhandled Rejection: ").concat(reason), 'unhandled_errors'));
    });
};
exports.applyUnhandledExceptionHandler = applyUnhandledExceptionHandler;
